import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ImageContent = ({
  className,
  image,
  imageColumn,
  contentColumn,
  cta,
  contentTitle,
  contentSubtitle
}) => {
  return /*#__PURE__*/_jsx("div", {
    className: `image-content ${className}`,
    children: /*#__PURE__*/_jsxs("div", {
      className: `row ${className}__row`,
      children: [/*#__PURE__*/_jsx("div", {
        className: `${className}__image-wrapper ${imageColumn}`,
        children: /*#__PURE__*/_jsxs("div", {
          className: `${className}__image-wrapper`,
          children: [/*#__PURE__*/_jsx("img", {
            src: image.src,
            alt: image.alt,
            className: image.class
          }), cta && /*#__PURE__*/_jsx("a", {
            className: `${className}__cta btn btn-outline-secondary d-block d-md-none`,
            href: cta.href,
            target: "_blank",
            "data-action": "Click",
            "data-tracking": "true",
            "data-label": "Branch CTA",
            rel: "noreferrer",
            children: cta.label
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: `${className}__content-wrapper ${contentColumn}`,
        children: [/*#__PURE__*/_jsx("p", {
          className: `${className}__title`,
          children: contentTitle
        }), /*#__PURE__*/_jsx("p", {
          className: `${className}__subtitle`,
          children: contentSubtitle
        }), cta && /*#__PURE__*/_jsx("a", {
          className: `${className}__cta btn btn-outline-secondary d-none d-md-block`,
          href: cta.href,
          target: "_blank",
          "data-action": "Click",
          "data-tracking": "true",
          "data-label": "Branch CTA",
          rel: "noreferrer",
          children: cta.label
        })]
      })]
    })
  });
};
export default ImageContent;